// extracted by mini-css-extract-plugin
export default {"expandButton":"ExpandButton_expandButton__jlKIO","hideButton":"ExpandButton_hideButton__CLSFn"};